var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgMd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7304_39582)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.1502 1.19072C15.5787 0.427875 13.8157 0 11.9532 0C10.0907 0 8.32767 0.427875 6.75621 1.19072L5.7168 12L6.75621 22.8093C8.32767 23.5721 10.0907 24 11.9532 24C13.8157 24 15.5787 23.5721 17.1502 22.8093L18.1896 12L17.1502 1.19072Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.75613 1.19115C2.7579 3.1321 0 7.24252 0 12C0 16.7575 2.7579 20.8679 6.75613 22.8089V1.19115Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1501 1.19115V22.8089C21.1484 20.8679 23.9063 16.7575 23.9063 12C23.9063 7.24252 21.1484 3.1321 17.1501 1.19115Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1108 9.44152H13.2525C13.2525 8.72115 12.6708 8.13718 11.9532 8.13718C11.2357 8.13718 10.654 8.72115 10.654 9.44152H7.79565C7.79565 10.1508 8.4111 10.7257 9.1175 10.7257H9.07492C9.07492 11.435 9.64764 12.01 10.3542 12.01C10.3542 12.638 10.8035 13.1598 11.3968 13.2714L10.3887 15.5562C10.8718 15.7533 11.3997 15.8628 11.9532 15.8628C12.5068 15.8628 13.0347 15.7533 13.5177 15.5562L12.5097 13.2714C13.103 13.1598 13.5523 12.638 13.5523 12.01C14.2588 12.01 14.8316 11.435 14.8316 10.7257H14.7889C15.4954 10.7257 16.1108 10.1507 16.1108 9.44152V9.44152Z",
    fill: "#FF9811"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9532 11.2174L10.2642 12V13.5652L11.9532 14.6087L13.6422 13.5652V12L11.9532 11.2174Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2642 10.4348H13.6422V12H10.2642V10.4348Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7304_39582"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.9062,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMd);
export default __webpack_public_path__ + "static/media/md.d3a0b3b490467c3c4d5f0cb78d8fad1f.svg";
export { ForwardRef as ReactComponent };